import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recepit-credit-grid',
  templateUrl: './recepit-credit-grid.component.html',
  styleUrls: ['./recepit-credit-grid.component.css']
})
export class ReceiptCreditGridComponent implements OnInit {
  title = "Receipt Credit"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/general-transaction/recepit-credit-grid/recepit-credit-grid.component.ts